/* 708 Supply Co. — shipping protection toggle
   Mirrors the free-gift pattern in 708-theme.js: snippets/708-protect.liquid computes
   the state from the live cart on every render, and this file makes the cart match.

   On by default. Unticking stores "declined" as a cart attribute and pulls the line,
   and because the attribute rides along with the cart it stays off through page loads
   and all the way to checkout. Re-ticking clears it and the line comes back.

   Everything routes through window.c708Cart so the drawer and cart page re-render
   exactly the way they do for any other cart change. */
(function () {
  'use strict';

  var ATTRIBUTE = 'shipping_protection';
  var busy = false;
  var failed = false;

  function box() { return document.querySelector('[data-c708-protect]'); }
  function flag(el, name) { return el.getAttribute('data-protect-' + name) === 'true'; }

  /* Writes the opt-out flag onto the cart and re-renders from the same response. */
  function setDeclined(declined) {
    var C = window.c708Cart;
    var attributes = {};
    attributes[ATTRIBUTE] = declined ? 'declined' : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: attributes,
        sections: C.sectionsParam(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) { C.render(json.sections); });
  }

  /* Reconciles the cart with whatever Liquid just said the state should be. */
  function sync() {
    var C = window.c708Cart;
    if (!C || busy || failed) return;
    var el = box();
    if (!el) return;

    var eligible = flag(el, 'eligible');
    var declined = flag(el, 'declined');
    var inCart = flag(el, 'in-cart');
    var variant = el.getAttribute('data-protect-variant');
    var key = el.getAttribute('data-protect-key');

    if (eligible && !declined && !inCart && variant) {
      busy = true;
      C.add({ id: variant, quantity: 1 }, null, { silent: true }).then(function () {
        busy = false;
        /* If it still is not in the cart, the add is not going to work — stop trying
           rather than loop against the server on every render. */
        var fresh = box();
        if (fresh && !flag(fresh, 'in-cart')) failed = true;
      });
    } else if (inCart && key && (declined || !eligible)) {
      /* Safety net. A cart line key is "<variantId>:<hash>", so this refuses to remove
         anything that is not the protection variant itself. Without it, a snippet that
         resolved to the wrong product could hand us a real product's line key and we
         would quietly delete the shopper's kit. Belt and braces with the Liquid guard. */
      if (!variant || key.split(':')[0] !== String(variant)) return;
      busy = true;
      C.change(key, 0).then(function () { busy = false; });
    }
  }

  /* The checkbox is inside re-rendered markup, so this is delegated. */
  document.addEventListener('change', function (e) {
    var toggle = e.target && e.target.closest && e.target.closest('[data-c708-protect-toggle]');
    if (!toggle || !window.c708Cart) return;
    var wanted = toggle.checked;
    toggle.disabled = true;
    failed = false;
    setDeclined(!wanted)
      .then(function () { sync(); })
      .catch(function () {})
      .then(function () {
        var fresh = document.querySelector('[data-c708-protect-toggle]');
        if (fresh) fresh.disabled = false;
      });
  });

  /* The protection line carries its own Remove, because pulling the line on its own
     would just let sync() put it straight back. Decline instead, and the line goes. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-c708-protect-remove]');
    if (!btn || !window.c708Cart) return;
    e.preventDefault();
    btn.disabled = true;
    failed = false;
    setDeclined(true).then(function () { sync(); }).catch(function () {});
  });

  /* Re-check after every cart render, the same moment the gift bar is re-checked. */
  function hook() {
    var C = window.c708Cart;
    if (!C) { setTimeout(hook, 60); return; }
    if (!C.c708ProtectHooked) {
      var original = C.render;
      C.render = function (sections) {
        original.call(this, sections);
        sync();
      };
      C.c708ProtectHooked = true;
    }
    sync();
  }

  hook();
})();
